<div class="header">
    <h2>{{ 'licenses.modal.upgrade.title' | translate }}</h2>
    <button type="button" [attr.aria-label]="'common.close' | translate" class="close" data-test="licenses-upgrade-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading()) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'licenses.error.unavailable' | translate" />
} @else if (license(); as license) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'licenses.fieldset.basic' | translate }}</h2>

            <div class="field">
                <span class="label">{{ 'licenses.form.packageId' | translate }}</span>
                <span class="value">{{ license.packageName }}</span>
            </div>

            <div class="field">
                <span class="label">{{ 'licenses.upgrade.currentPricing' | translate }}</span>
                <span class="value">{{ license.pricing.label }} · {{ license.pricing.price | price: license.currency }}</span>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'licenses.fieldset.pricing' | translate }}</h2>

            <app-form-select
                [control]="form.controls.pricingTierId"
                [label]="'licenses.form.pricingTier' | translate"
                [options]="tierOptions()"
                [filter]="true"
                inputId="pricingTierId"
                testId="licenses-upgrade-pricing-tier-id"
            />

            <app-form-radio-button
                [control]="form.controls.billingTreatment"
                [label]="'licenses.form.billingTreatment' | translate"
                [options]="billingOptions"
                inputId="billingTreatment"
                name="billingTreatment"
                testId="licenses-upgrade-billing-treatment"
            />
        </div>
    </form>

    <div class="footer">
        <p-button [label]="'licenses.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="licenses-upgrade-cancel" (onClick)="close()" />
        <p-button
            type="submit"
            [label]="'licenses.upgrade.submit' | translate"
            [disabled]="saving()"
            data-test="licenses-upgrade-submit"
            (onClick)="onSubmit()"
        />
    </div>
}
